import React, { useState, useEffect } from 'react'
import {
    Paper,
    FormControl,
    TextField,
    Grid,
    Button,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import rolePermissionGroupService from '../../../../services/rolePermissionGroup.service'
import userRoleService from '../../../../services/userRole.service'

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    selectList: {
        height: 40,
    },
    loadingSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        width: '100%',
    },
}))

const Details = ({ rolePermissionGroupId }) => {
    const classes = useStyles()
    const [rolePermissionGroupDetails, setServiceDetails] = useState()
    const [userRoles, setUserRoles] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(true)

    useEffect(() => {
        ;(async function getGroupAsync() {
            try {
                await rolePermissionGroupService
                    .getPermissionGroup(rolePermissionGroupId)
                    .then(result => {
                        setServiceDetails(result)
                    })
                await userRoleService.getAllRoles().then(result => {
                    setUserRoles(result)
                })
                setIsLoadingData(false)
            } catch (exception) {
                console.log(exception)
            }
        })()
    }, [])

    const updateClickHandler = async () => {
        try {
            await rolePermissionGroupService.updatePermissionGroup({
                permissionGroupId: rolePermissionGroupDetails.id,
                roleId: rolePermissionGroupDetails.roleId,
                title: rolePermissionGroupDetails.title,
                isEnabled: rolePermissionGroupDetails.isEnabled,
            })
        } catch (exception) {
            console.log(exception)
        }
    }

    return (
        <>
            {isLoadingData ? (
                <>Loading....</>
            ) : (
                <Paper className={classes.paper}>
                    <Grid
                        container
                        direction='row'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={3}>
                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Id'}
                                    value={rolePermissionGroupDetails.id}
                                    disabled
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Name'}
                                    value={rolePermissionGroupDetails.title}
                                    onChange={e => {
                                        const val = e.target.value
                                        setServiceDetails({
                                            ...rolePermissionGroupDetails,
                                            title: val,
                                        })
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl>
                                <InputLabel required={true}>
                                    Role Type
                                </InputLabel>
                                <Select
                                    value={rolePermissionGroupDetails.roleId}
                                    onChange={e => {
                                        const val = e.target.value
                                        setServiceDetails({
                                            ...rolePermissionGroupDetails,
                                            roleId: val,
                                        })
                                    }}>
                                    {userRoles.map(role => {
                                        return (
                                            <MenuItem value={role.id}>
                                                {role.value}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        direction='row'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={3}>
                        <Grid item xs={4}>
                            <FormControl>
                                <InputLabel required={true}>
                                    Is Enabled?
                                </InputLabel>
                                <Select
                                    value={rolePermissionGroupDetails.isEnabled}
                                    onChange={e => {
                                        const val = e.target.value
                                        setServiceDetails({
                                            ...rolePermissionGroupDetails,
                                            isEnabled: val,
                                        })
                                    }}>
                                    <MenuItem value={true}>Yes</MenuItem>
                                    <MenuItem value={false}>No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid
                            container
                            item
                            xs={12}
                            direction='row'
                            justify='flex-start'>
                            <Button
                                variant='contained'
                                color='secondary'
                                onClick={updateClickHandler}>
                                Update
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            )}
        </>
    )
}

export default Details
